import { render, staticRenderFns } from "./ModalContentDeleteReminder.vue?vue&type=template&id=4b7c3096&scoped=true&"
import script from "./ModalContentDeleteReminder.vue?vue&type=script&lang=js&"
export * from "./ModalContentDeleteReminder.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentDeleteReminder.vue?vue&type=style&index=0&id=4b7c3096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7c3096",
  null
  
)

export default component.exports